<!-- components/About.svelte -->
<script>
  import { t } from "../libs/i18n";
  import NewContentTopList from '../components/NewContentTopList.svelte'
  import NewContentBottomList from '../components/NewContentBottomList.svelte'
</script>


<!-- ======= About Section ======= -->
<section id="new_contents" class="new-contens">
  <div class="container">
    <div class="row content">
      <div class="col-lg-12 p-4 new-content-intro">
        <div class="col-sm-12 col-md-6 col-lg-6 offset-3 mb-3 new-contens-info-block">
          <h1 class="new-content-title">{$t("new_content.title")}</h1>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 offset-3 new-contens-info-block">
          <span class="new-content-discribe">{$t("new_content.discribe")}</span>
        </div>
      </div>
      <NewContentTopList />
      <NewContentBottomList />
    </div>
  </div>
</section><!-- End About Section -->